import axios, { ResponseType, auth } from './axios';
import { API_SOLUTION } from '~/env';
import { Profile, Employee } from '~/types';
import { getPermissions } from '~/utils/permissions';
import { store } from '~/store';
import { loadPermissionsBegin, loadPermissionsSuccess } from '~/slices/ui';

export const beginSmsOtp = (req: {
  phoneNumber?: string;
  invitationToken?: string;
  captchaToken?: string;
}): ResponseType<{ challengeToken: string }> => {
  const { captchaToken, ...rest } = req;
  return axios.post(
    '/auth/smsotp/beginChallenge',
    rest,
    captchaToken ? { headers: { 'g-recaptcha-response': captchaToken } } : undefined
  );
};

const smsOtp = (challengeToken: string, otp: string, name?: string): ResponseType => {
  return axios.post(smsOtp.url, { challengeToken, otp, name });
};
smsOtp.url = '/auth/smsotp/authenticate';
export const authenticateSmsOtp = smsOtp;

export const beginEmailOtp = (
  email: string,
  name?: string
): ResponseType<{ challengeToken: string }> => {
  return axios.post('/auth/emailotp/beginChallenge', { email, name });
};

const emailOtp = (challengeToken: string, otp: string): ResponseType => {
  return axios.post(emailOtp.url, { challengeToken, otp });
};
emailOtp.url = '/auth/emailotp/authenticate';
export const authenticateEmailOtp = emailOtp;

export const setPassword = (newPassword: string): ResponseType => {
  return axios.put('/auth/password', { newPassword });
};

export const createBusiness = (data: { [x: string]: any }): ResponseType => {
  const { firstName, lastName, ...rest } = data;
  return axios.post('/businesses', { solutionId: API_SOLUTION, ...rest });
};

export type Identity = {
  phoneNumber: string;
  emailAddress?: string;
  username?: string;
  hasPassword: boolean;
  roles: Record<string, Employee['roles']>;
  name: string;
};

const getAlreadyFilledDataRequest = (): ResponseType<Identity> => {
  store.dispatch(loadPermissionsBegin());
  return axios.get<Identity>('/auth/identity').then((value) => {
    const { roles } = value.data;
    const rolesArr = roles[auth.getProfile() || ''];
    if (rolesArr) {
      store.dispatch(loadPermissionsSuccess(getPermissions(rolesArr)));
    }
    return value;
  });
};
getAlreadyFilledDataRequest.url = '/auth/identity';

export const getAlreadyFilledData = getAlreadyFilledDataRequest;

export const getProfiles = (): ResponseType<Profile[]> => {
  return axios.get('/profiles');
};
